import _ from 'lodash';

import { MARK_BADGE_STEP_PX, PERCENT } from './PreviewPagePane.constants';

/** A fraction of the page as a CSS percentage. */
export const toPercent = fraction => `${fraction * PERCENT}%`;

/**
 * The page's marks top to bottom, each with its number's top in px on a page `pageHeight` px high:
 * level with its part, or just below the number above when the two would overlap.
 */
export const getStackedBadges = (marks, pageHeight) =>
  _.sortBy(marks, ['top', 'number']).reduce((badges, mark) => {
    const previous = _.last(badges);
    const badgeTop = previous
      ? Math.max(mark.top * pageHeight, previous.badgeTop + MARK_BADGE_STEP_PX)
      : mark.top * pageHeight;

    return [...badges, { id: mark.id, number: mark.number, badgeTop }];
  }, []);
